import { useEffect } from "react";

const useManageCookieBtn = () => {
	useEffect(() => {
		const fixElement = (node) => {
			if (!node || node.nodeType !== Node.ELEMENT_NODE) return;
			// A directly added <a> must pass the same javascript: check as nested ones —
			// otherwise any real link React inserts on its own (e.g. a translated message's
			// <a href='https://...'>) gets its href replaced with '#' and its click blocked.
			const anchors = node.matches('a[href^="javascript:"]') ? [node] : [...node.querySelectorAll('a[href^="javascript:"]')];
			anchors?.forEach((anchor) => {
				const code = anchor.getAttribute('href')?.replace(/^javascript:\s*/i, '');
				if (!code) return;
				anchor.setAttribute('href', '#');
				anchor.addEventListener('click', (e) => {
					e.preventDefault();
					if (code !== 'void(0)' && code !== 'void 0') {
						try {
							const trimmedCode = code.trim();
							if ((trimmedCode === 'cookieBanner.expand()' || trimmedCode === 'cookieBanner.expand();') && typeof window.cookieBanner?.expand === 'function') {
								// calling with this exact function name to avoid any other XSS injections.
								window.cookieBanner.expand();
							}
						} catch (err) {
							console.error(err);
						}
					}
				});
			});
		};

		fixElement(document.body);

		const observer = new MutationObserver((mutations) => {
			mutations.flatMap(m => [...m.addedNodes]).forEach(fixElement);
		});

		observer.observe(document.body, { childList: true, subtree: true });
		return () => observer.disconnect();
	}, []);
};

export default useManageCookieBtn;
